import React, { useEffect, useRef } from 'react';

type PreContractOneDrawEmbedProps = {
    salesForceId: string;
};

/**
 * Embeds the real oneDRAW Three.js editor canvas via /configure
 * (canvas-only: app=oneBUTTON + view=onedraw + embed=viewport).
 *
 * Loads the iframe src once per opportunity id — parent must keep this mounted
 * (park / dock with CSS) and must not remount on section navigation.
 */
export const PreContractOneDrawEmbed: React.FC<PreContractOneDrawEmbedProps> = ({
    salesForceId,
}) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const loadedSfidRef = useRef<string | null>(null);

    useEffect(() => {
        const id = salesForceId.trim();
        const iframe = iframeRef.current;
        if (!id || !iframe) return;
        if (loadedSfidRef.current === id) return;

        const params = new URLSearchParams({
            sfid: id,
            view: 'onedraw',
            app: 'oneBUTTON',
            embed: 'viewport',
        });
        loadedSfidRef.current = id;
        iframe.src = `/configure?${params.toString()}`;
    }, [salesForceId]);

    if (!salesForceId.trim()) {
        return (
            <div className="pci-onedraw-embed pci-onedraw-embed--idle">
                <p>Missing opportunity id — cannot load the 3D viewer.</p>
            </div>
        );
    }

    return (
        <div className="pci-onedraw-embed">
            <iframe
                ref={iframeRef}
                id="pci-onedraw-embed-frame"
                className="pci-onedraw-embed__frame"
                title="oneDRAW 3D viewer"
                allow="fullscreen"
            />
        </div>
    );
};

export default PreContractOneDrawEmbed;
